import { hoverStyle } from "@/styles/theme";
import { Box, Tooltip, Typography } from "@mui/material";
import { AccountDialog } from "@organisms/AccountDialog";
import { Images } from "@shared/constants/Images";
import { useSideMenu } from "@shared/contexts/SideMenuContext";
import { useUserAccount } from "@shared/contexts/UserAccountContext";
import { useAccountDialogPosition } from "@shared/hooks/sideMenu/useAccountDialogPosition";

export const UserAccountBadge = () => {
  const { isOpenSideMenu } = useSideMenu();
  const userAccount = useUserAccount();
  const {
    isAccountDialogOpen,
    openAccountDialog,
    closeAccountDialog,
    dialogTop,
    dialogLeft,
  } = useAccountDialogPosition();

  const handleClick = () => {
    if (isAccountDialogOpen) {
      closeAccountDialog();
    } else {
      openAccountDialog();
    }
  };

  const content = (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        mt: 3,
        mb: 1,
        alignItems: "center",
        justifyContent: "flex-start",
        ...hoverStyle,
      }}
      onClick={handleClick}
    >
      <img
        src={Images.icons.sideMenu.account}
        alt="アカウントアイコン"
        width={40}
        height={40}
      />
      {isOpenSideMenu && (
        <Box sx={{ gap: 4 }}>
          <Typography>{userAccount.accountName}</Typography>
          <Typography sx={{ fontSize: 13, color: "#6B7280", mt: 0.2 }}>
            {userAccount.roleName}
          </Typography>
        </Box>
      )}
      <AccountDialog
        open={isAccountDialogOpen}
        onClose={closeAccountDialog}
        actions={null}
        sx={{
          "& .MuiPaper-root": {
            display: "block",
            position: "absolute",
            top: dialogTop,
            left: dialogLeft,
          },
        }}
      />
    </Box>
  );

  if (isOpenSideMenu || isAccountDialogOpen) return content;

  return (
    <Tooltip title={"アカウントメニュー"} placement="right">
      {content}
    </Tooltip>
  );
};
